import { LifebuoyIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { BG, BORDER, TEXT } from "~/components/theme/colors";

export const HELP_LAUNCHER_POSITION_CLASSES =
  "fixed bottom-11 right-20 z-50 sm:right-[7.5rem] lg:right-[5.5rem]";

type HelpLauncherButtonProps = {
  onClick: () => void;
  className?: string;
};

const ChatLauncherButton = ({
  onClick,
  className,
}: HelpLauncherButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        "inline-flex items-center gap-2 rounded-full border px-4 py-2.5 text-sm font-semibold shadow-lg transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-300",
        BORDER.primary,
        BG.surfaceMuted,
        TEXT.primary,
        "hover:bg-sky-800 hover:text-white",
        className
      )}
      aria-label="Otwórz panel pomocy"
    >
      <LifebuoyIcon className="h-5 w-5" />
      <span>Pomoc</span>
    </button>
  );
};

export default ChatLauncherButton;
